import { reviews } from '@/mocks/reviews';
import ReviewCard from '@/components/base/ReviewCard';

export default function ReviewSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-1">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-foreground-500 font-label uppercase tracking-wider">Reviews</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            瓜友神评广场
          </h2>
          <p className="text-sm text-foreground-600 mt-2">看看广大瓜友们怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, index) => (
            <ReviewCard
              key={review.id}
              username={review.username}
              avatar={review.avatar}
              role={review.role}
              rating={review.rating}
              title={review.title}
              content={review.content}
              faded={index === reviews.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
}